import { useState } from "react"
import MapGL, { Marker } from "react-map-gl/mapbox"
import { StreetViewMap } from "./street-view-map"

const MAPBOX_STREET_STYLE = "kaptcher/cm1umwib0015k01qr8tra14o9"

interface StreetViewModeProps {
  mapboxToken: string
  longitude: number
  latitude: number
  googleMapsKey: string
}

export const StreetViewMode = ({ mapboxToken, longitude, latitude, googleMapsKey }: StreetViewModeProps) => {
  const [streetViewPosition, setStreetViewPosition] = useState<[number, number] | null>(null)

  return (
    <div className="flex w-full h-full">
      <div className="w-1/2 h-full relative">
        <MapGL
          initialViewState={{ longitude, latitude, zoom: 14 }}
          mapStyle={`mapbox://styles/${MAPBOX_STREET_STYLE}`}
          mapboxAccessToken={mapboxToken}
          style={{ height: "100%", width: "100%" }}
          onClick={(e) => setStreetViewPosition([e.lngLat.lng, e.lngLat.lat])}
        >
          {streetViewPosition && <Marker longitude={streetViewPosition[0]} latitude={streetViewPosition[1]} />}
        </MapGL>
        <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-3 py-2 rounded-lg shadow text-sm text-gray-600">
          Cliquez sur la carte pour déplacer Street View
        </div>
      </div>
      <div className="w-1/2 h-full">
        {streetViewPosition ? (
          <StreetViewMap coordinates={streetViewPosition} googleMapsKey={googleMapsKey} />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-100">
            <p className="text-gray-500">Cliquez sur la carte pour afficher Street View</p>
          </div>
        )}
      </div>
    </div>
  )
}
